
import { ContentProcessorConfig } from '../types';

/**
 * Processes HTML content with additional options
 */
export const processHtml = (
  content: string, 
  config: ContentProcessorConfig
): string => {
  if (!content) return '';
  
  let processedHtml = content;
  
  // Apply Tailwind classes if requested
  if (config.applyTailwind) {
    // Add basic responsive Tailwind classes
    processedHtml = processedHtml
      .replace(/<h1/g, '<h1 class="text-4xl md:text-5xl font-bold mb-6"')
      .replace(/<h2/g, '<h2 class="text-3xl md:text-4xl font-semibold mb-4"')
      .replace(/<h3/g, '<h3 class="text-2xl md:text-3xl font-semibold mb-3"')
      .replace(/<p>/g, '<p class="mb-4 text-gray-700">');
  }
  
  // Parse and optimize images if requested
  if (config.parseImages) {
    // Add responsive image classes and lazy loading
    processedHtml = processedHtml.replace(
      /<img\s+src="([^"]+)"\s*([^>]*)>/g, 
      '<img src="$1" $2 loading="lazy" class="max-w-full h-auto rounded my-4">'
    );
  }
  
  // Remove metadata headers if requested
  if (config.stripMetadata) {
    // Remove any front matter or metadata sections
    processedHtml = processedHtml.replace(/^---[\s\S]*?---/, '');
  }
  
  return processedHtml;
};
